"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validateAndPrepareResetPasswordModel_1 = require("./validateAndPrepareResetPasswordModel");

exports.validateAndPrepareResetPasswordModel = validateAndPrepareResetPasswordModel_1.validateAndPrepareResetPasswordModel;